/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAttachScenarioDto,
  ApiCreateWillAttachmentDto,
  ApiCreateWillDto,
  ApiCreateWillParticipantDto,
  ApiUpdateWillAttachmentDto,
  ApiWillAttachmentResponse,
  ApiWillParticipantResponse,
  ApiWillResponse,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Wills<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Only Capital Founders can create wills. The will is created in DRAFT status without a number.
   *
   * @tags Wills
   * @name WillControllerCreate
   * @summary Create a new will
   * @request POST:/wills
   * @secure
   * @response `201` `ApiWillResponse` Will created successfully
   * @response `403` `void` Only Capital Founders can create wills
   */
  willControllerCreate = (data: ApiCreateWillDto, params: RequestParams = {}) =>
    this.request<ApiWillResponse, ApiBaseError>({
      path: `/wills`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns wills where user is creator or participant
   *
   * @tags Wills
   * @name WillControllerFindAll
   * @summary Get all wills for current user
   * @request GET:/wills
   * @secure
   * @response `200` `(ApiWillResponse)[]` Wills retrieved successfully
   */
  willControllerFindAll = (params: RequestParams = {}) =>
    this.request<ApiWillResponse[], ApiBaseError>({
      path: `/wills`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns will details if user has access (creator or participant)
   *
   * @tags Wills
   * @name WillControllerFindOne
   * @summary Get will by ID
   * @request GET:/wills/{id}
   * @secure
   * @response `200` `ApiWillResponse` Will data retrieved successfully
   * @response `403` `void` No access to this will
   * @response `404` `void` Will not found
   */
  willControllerFindOne = (id: string, params: RequestParams = {}) =>
    this.request<ApiWillResponse, ApiBaseError>({
      path: `/wills/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Only the creator can delete a will. Can delete both DRAFT and EXECUTED (annul) wills.
   *
   * @tags Wills
   * @name WillControllerRemove
   * @summary Delete will or annul executed will
   * @request DELETE:/wills/{id}
   * @secure
   * @response `200` `void` Will deleted/annulled successfully
   * @response `403` `void` Only creator can delete will
   */
  willControllerRemove = (id: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/wills/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Only the creator can add participants to a will. Only allowed for DRAFT wills.
   *
   * @tags Wills
   * @name WillControllerAddParticipant
   * @summary Add participant to will
   * @request POST:/wills/{id}/participants
   * @secure
   * @response `201` `ApiWillParticipantResponse` Participant added successfully
   * @response `400` `void` Business rule violation (role limits, conflicts, etc.) or will is EXECUTED
   * @response `403` `void` Only creator can add participants
   */
  willControllerAddParticipant = (
    id: string,
    data: ApiCreateWillParticipantDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiWillParticipantResponse, ApiBaseError>({
      path: `/wills/${id}/participants`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns list of participants if user has access to will
   *
   * @tags Wills
   * @name WillControllerGetParticipants
   * @summary Get participants of will
   * @request GET:/wills/{id}/participants
   * @secure
   * @response `200` `(ApiWillParticipantResponse)[]` Participants retrieved successfully
   * @response `403` `void` No access to this will
   */
  willControllerGetParticipants = (id: string, params: RequestParams = {}) =>
    this.request<ApiWillParticipantResponse[], ApiBaseError>({
      path: `/wills/${id}/participants`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Only the creator can remove participants from a will. Only allowed for DRAFT wills.
   *
   * @tags Wills
   * @name WillControllerRemoveParticipant
   * @summary Remove participant from will
   * @request DELETE:/wills/{id}/participants/{participantId}
   * @secure
   * @response `200` `void` Participant removed successfully
   * @response `400` `void` Will is EXECUTED, cannot remove participants
   * @response `403` `void` Only creator can remove participants
   */
  willControllerRemoveParticipant = (
    id: string,
    participantId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/wills/${id}/participants/${participantId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns list of attachments for the will
   *
   * @tags Wills
   * @name WillControllerGetAttachments
   * @summary Get will attachments
   * @request GET:/wills/{id}/attachments
   * @secure
   * @response `200` `(ApiWillAttachmentResponse)[]` Attachments retrieved successfully
   */
  willControllerGetAttachments = (id: string, params: RequestParams = {}) =>
    this.request<ApiWillAttachmentResponse[], ApiBaseError>({
      path: `/wills/${id}/attachments`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Only will creator can add attachments. First attachment will approve the will (DRAFT → APPROVED).
   *
   * @tags Wills
   * @name WillControllerAddAttachment
   * @summary Add attachment to will
   * @request POST:/wills/{id}/attachments
   * @secure
   * @response `201` `ApiWillAttachmentResponse` Attachment added successfully. Will may be executed if this was the first attachment.
   * @response `400` `void` Will is already EXECUTED, cannot add more attachments
   * @response `403` `void` Only will creator can add attachments
   */
  willControllerAddAttachment = (
    id: string,
    data: ApiCreateWillAttachmentDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiWillAttachmentResponse, ApiBaseError>({
      path: `/wills/${id}/attachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Only will creator can update attachments
   *
   * @tags Wills
   * @name WillControllerUpdateAttachment
   * @summary Update will attachment
   * @request PATCH:/wills/{id}/attachments/{attachmentId}
   * @secure
   * @response `200` `ApiWillAttachmentResponse` Attachment updated successfully
   * @response `403` `void` Only will creator can update attachments
   * @response `404` `void` Attachment not found
   */
  willControllerUpdateAttachment = (
    id: string,
    attachmentId: string,
    data: ApiUpdateWillAttachmentDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiWillAttachmentResponse, ApiBaseError>({
      path: `/wills/${id}/attachments/${attachmentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Allows attaching a scenario to a will after creation
   *
   * @tags Wills
   * @name WillControllerAttachScenario
   * @summary Attach a scenario to an existing will
   * @request PATCH:/wills/{id}/attach-scenario
   * @secure
   * @response `200` `ApiWillResponse` Scenario attached successfully
   * @response `403` `void` Only will creator can attach scenarios
   * @response `404` `void` Will not found
   */
  willControllerAttachScenario = (
    id: string,
    data: ApiAttachScenarioDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiWillResponse, ApiBaseError>({
      path: `/wills/${id}/attach-scenario`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Retrieve will linked to a specific scenario
   *
   * @tags Wills
   * @name WillControllerFindByScenarioId
   * @summary Get will by scenario ID
   * @request GET:/wills/by-scenario/{scenarioId}
   * @secure
   * @response `200` `ApiWillResponse` Will retrieved successfully or null if not found
   */
  willControllerFindByScenarioId = (
    scenarioId: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiWillResponse, ApiBaseError>({
      path: `/wills/by-scenario/${scenarioId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
